import React, { useState } from "react";
import { Textarea, TextInput, Stack, Button, Modal, Flex } from "@mantine/core";

export default function GoogleTagManagerSettings({
  settings,
  onChange,
  onSaveClick,
}) {
  // GTM ID validation
  const gtmIdPattern = /^GTM-[A-Z0-9]{1,8}$/;
  const isGtmIdValid = settings.gtm_id
    ? true
    // ? gtmIdPattern.test(settings.gtm_id)
    : true; // Allow empty (optional)
  const hasGtmId = settings.gtm_id && settings.gtm_id.trim() !== "";

  return (
    <Stack gap="md">
      <TextInput
        label="Google tag ID"
        description="Paste your Google tag ID here"
        value={settings.gtm_id || ""}
        onChange={(e) => {
          onChange({ ...settings, gtm_id: e.target.value });
        }}
      />
      {/* <Textarea
        label="Header Code"
        description="Paste your Google Tag Manager header code here. Should include script tags with GTM script reference."
        value={settings.gtm_header_code || ""}
        onChange={(e) => {
          onChange({ ...settings, gtm_header_code: e.target.value });
        }}
        autosize
        minRows={3}
      />

      <Textarea
        label="Body Code"
        description="Paste your Google Tag Manager body code here. Should include noscript tags with GTM noscript reference."
        value={settings.gtm_body_code || ""}
        onChange={(e) => {
          onChange({ ...settings, gtm_body_code: e.target.value });
        }}
        autosize
        minRows={3}
      /> */}

      <Button onClick={onSaveClick} disabled={hasGtmId && !isGtmIdValid}>
        Save
      </Button>
      <Flex justify="center">
        <ExtractId onSuccess={(id) => onChange({ ...settings, gtm_id: id })} />
      </Flex>
    </Stack>
  );
}

const ExtractId = ({ onSuccess }) => {
  const [opened, setOpened] = useState(false);
  const [code, setCode] = useState("");
  const [extractedId, setExtractedId] = useState("");
  const [error, setError] = useState("");

  function onClose() {
    setOpened(false);
    setCode("");
    setExtractedId("");
    setError("");
  }

  const extractGTMId = (code) => {
    if (!code || code.trim() === "") {
      setError("Please paste your Google Tag Manager code");
      return;
    }

    const trimmedCode = code.trim();

    // Try to extract GTM ID from various patterns
    const patterns = [
      // Pattern 1: GTM-XXXXXXX in the script src
      /googletagmanager\.com\/gtm\.js\?id=(GTM-[A-Z0-9]+)/i,
      // Pattern 2: GTM-XXXXXXX in the noscript src
      /googletagmanager\.com\/ns\.html\?id=(GTM-[A-Z0-9]+)/i,
      // Pattern 3: GTM-XXXXXXX in dataLayer
      /dataLayer['"]\s*,\s*['"](GTM-[A-Z0-9]+)['"]/i,
      // Pattern 4: GTM-XXXXXXX in the script content
      /['"](GTM-[A-Z0-9]+)['"]/i,
      // Pattern 5: Just the GTM ID by itself
      /(GTM-[A-Z0-9]+)/i,
    ];

    for (const pattern of patterns) {
      const match = trimmedCode.match(pattern);
      if (match && match[1]) {
        const gtmId = match[1].toUpperCase();
        setExtractedId(gtmId);
        setError("");
        return gtmId;
      }
    }

    setError(
      "Could not find a valid GTM ID in the code. Please make sure you've pasted the complete Google Tag Manager code."
    );
    setExtractedId("");
  };

  const handleExtract = () => {
    const id = extractGTMId(code);
    if (id) {
      onSuccess(id);
      onClose();
    }
  };

  return (
    <div>
      <Button
        onClick={() => setOpened(true)}
        variant="light"
        size="xs"
        color="gray"
      >
        Help!
      </Button>
      <Modal opened={opened} onClose={onClose} title="Extract GTM ID">
        <Stack gap="md">
          <Textarea
            label="Google Tag Manager Code"
            description="Paste your complete Google Tag Manager code here. It can be header or body code."
            placeholder="<!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-XXXXXXX');</script>
<!-- End Google Tag Manager -->"
            autosize
            minRows={8}
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError("");
              setExtractedId("");
            }}
          />

          {extractedId && (
            <div
              style={{
                padding: "12px",
                backgroundColor: "var(--mantine-color-green-light)",
                border: "1px solid var(--mantine-color-green-6)",
                borderRadius: "4px",
              }}
            >
              <strong>Extracted GTM ID:</strong> {extractedId}
            </div>
          )}

          {error && (
            <div
              style={{
                padding: "12px",
                backgroundColor: "var(--mantine-color-red-light)",
                border: "1px solid var(--mantine-color-red-6)",
                borderRadius: "4px",
                color: "var(--mantine-color-red-6)",
              }}
            >
              {error}
            </div>
          )}

          <div
            style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}
          >
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={handleExtract} disabled={!code.trim()}>
              Extract ID
            </Button>
          </div>
        </Stack>
      </Modal>
    </div>
  );
};
